import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpune() {



  const cardData = {
"keyword": "Urbania on rent in Pune",

"headingDescription":
  "Shivai Travels offers premium Urbania on rent in Pune for luxury group travel, corporate trips, weddings, airport transfers, pilgrimages, and outstation journeys. Whether you are planning a family tour, business travel, weekend getaway, or long-distance road trip, our Force Urbania service ensures maximum comfort, safety, and style throughout the journey. With spacious pushback seats, powerful air-conditioning, modern interiors, ample luggage space, and experienced professional drivers, we provide a smooth and hassle-free travel experience from Pune. Our Urbania fleet is ideal for medium to large groups looking for a luxury travel upgrade over regular tempo travellers. With flexible rental options (local, outstation, and multi-day packages), doorstep pickup, easy booking, and 24/7 support, Shivai Travels ensures a comfortable, premium, and reliable group travel experience.",

"topPlaces": [
  
  {
    "title": "Goa",
    "description":
      "Goa is a popular long-distance group travel destination from Pune, famous for beaches, nightlife, and water sports, ideal for luxury Urbania road trips."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, frequently visited by families and groups using Urbania vans for comfortable darshan travel."
  },
  {
    "title": "Nashik & Trimbakeshwar",
    "description":
      "Nashik is known for Trimbakeshwar Jyotirlinga and vineyards, making it a popular spiritual and leisure destination for group travel from Pune."
  },
  {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular short-distance hill stations near Pune, known for misty valleys, waterfalls, viewpoints, and monsoon beauty. Urbania rentals are commonly used for luxury group trips here."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a famous hill station known for strawberries, viewpoints, and cool climate, making it a top destination for Urbania group tours from Pune."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal beach destination near Mumbai known for clean beaches, forts, and resorts, often chosen for weekend Urbania group tours."
  },
  {
    "title": "Konkan Beaches (Murud, Kashid, Diveagar)",
    "description":
      "Konkan beaches like Murud Janjira, Kashid, and Diveagar are popular group getaway destinations from Pune for beach relaxation and scenic coastal drives."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description":
      "Ajanta and Ellora Caves near Aurangabad are UNESCO World Heritage Sites and are frequently visited by tourist groups using luxury Urbania vans."
  },
  {
    "title": "Pune City Sightseeing",
    "description":
      "Urbania rentals are also used for Pune city tours covering Shaniwar Wada, Aga Khan Palace, Dagdusheth Temple, and other cultural landmarks."
  },
  {
    "title": "Western Ghats Scenic Routes",
    "description":
      "Urbania journeys from Pune often pass through the Western Ghats, offering lush greenery, ghats, tunnels, and scenic landscapes for a premium travel experience."
  }
],



services: [
  {
    name: "Force Urbania Rental Pune",
    description: "Force Urbania rental Pune service provides premium group transportation for family trips, corporate tours, weddings, airport transfers, and luxury outstation journeys. Modern Urbania vehicles with experienced drivers ensure smooth and safe travel for local and long-distance routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer spacious interiors, pushback seating, air conditioning, and luggage space suitable for luxury travel needs. Flexible booking options allow convenient Force Urbania rental reservations in Pune."
  },
  {
    name: "Urbania Van on Rent Pune",
    description: "Urbania van on rent Pune service offers dependable luxury transportation solutions for groups traveling within Pune and nearby destinations. Vehicles provide spacious seating and comfortable highway travel suitable for tourism, corporate outings, pilgrimage tours, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient Urbania van rental reservations."
  },
  {
    name: "Pune Urbania Booking Service",
    description: "Pune Urbania booking service provides premium and comfortable group travel options for local and outstation journeys. Travelers can enjoy smooth trips with experienced drivers familiar with city roads, highways, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for weddings, family vacations, and corporate travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Urbania booking reservations."
  },
  {
    name: "Luxury Urbania Pune Rent",
    description: "Luxury Urbania Pune rent service provides high-end transportation for passengers seeking comfortable and stylish group travel. Vehicles offer spacious seating, premium interiors, luggage capacity, and smooth ride quality suitable for tourism, wedding events, and executive travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient luxury Urbania reservations."
  },
  {
    name: "Urbania Tempo Traveller Pune",
    description: "Urbania Tempo Traveller Pune service offers economical and comfortable luxury transportation for small and large groups traveling within Pune and nearby destinations. Vehicles provide smooth highway travel with spacious seating suitable for one-day tours, outstation journeys, and group outings. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Urbania Tempo Traveller reservations."
  },
  {
    name: "12 Seater Urbania on Rent Pune",
    description: "12 seater Urbania on rent Pune service provides comfortable transportation for small groups, families, and corporate teams traveling within Pune and outstation destinations. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, pilgrimage tours, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient 12 seater Urbania reservations."
  },
  {
    name: "16 Seater Urbania Rental Pune",
    description: "16 seater Urbania rental Pune service offers spacious transportation for medium-sized groups traveling for family tours, corporate outings, weddings, and sightseeing trips. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 16 seater Urbania reservations."
  },
  {
    name: "Urbania for Outstation Pune",
    description: "Urbania for outstation Pune service provides reliable transportation for larger groups traveling for tours, weddings, pilgrimage trips, and corporate events. Vehicles offer spacious seating, luggage space, and comfortable travel suitable for local and outstation journeys. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "Cheap Urbania Rent Pune",
    description: "Cheap Urbania rent Pune service provides dependable transportation for long-distance group travel from Pune to tourist destinations, pilgrimage places, beaches, and hill stations. Comfortable vehicles ensure smooth highway travel suitable for tourism, corporate tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient affordable Urbania reservations."
  },
  {
    name: "Wedding Urbania Pune Hire",
    description: "Wedding Urbania Pune hire service offers spacious and comfortable transportation for wedding guests, family functions, receptions, and destination wedding travel. Vehicles provide comfortable seating and luggage space suitable for safe and enjoyable wedding journeys. Professional drivers ensure punctual pickup and dependable transportation services throughout the trip. Pickup services are available from homes, hotels, railway stations, banquet halls, and airports across Pune. Flexible booking options allow convenient wedding Urbania reservations."
  },
  {
    name: "Pune Urbania Cab Service",
    description: "Pune Urbania cab service provides premium group transportation for weddings, family tours, airport transfers, sightseeing trips, and corporate events. Vehicles ensure comfortable seating and smooth travel suitable for large family groups and business transportation. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient Urbania cab reservations."
  },
  {
    name: "Urbania Rental with Driver Pune",
    description: "Urbania rental with driver Pune service offers reliable group transportation for airport pickup and drop services, sightseeing tours, and outstation travel. Vehicles provide spacious seating and luggage space suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Urbania rental with driver reservations."
  },
  {
    name: "Premium Urbania Van Pune",
    description: "Premium Urbania van Pune service provides complete luxury transportation solutions for local and outstation group travel requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, pilgrimage tours, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient premium Urbania van reservations."
  },
  {
    name: "Pune Urbania for Group Travel",
    description: "Pune Urbania for group travel service offers comfortable and dependable transportation with modern vehicles and experienced chauffeurs. Vehicles are suitable for weddings, family trips, airport transfers, sightseeing tours, and outstation travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Urbania group travel reservations."
  },
  {
    name: "Best Urbania Rental Pune",
    description: "Best Urbania rental Pune service provides luxury transportation for groups looking for premium travel experiences with spacious seating and comfortable interiors. Vehicles are suitable for corporate events, destination weddings, sightseeing trips, and family tours. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient best Urbania rental reservations."
  }
],

tableData: [
  ["Force Urbania Rental Pune", "Urbania Van on Rent Pune"],
  ["Pune Urbania Booking Service", "Luxury Urbania Pune Rent"],
  ["Urbania Tempo Traveller Pune", "12 Seater Urbania on Rent Pune"],
  ["16 Seater Urbania Rental Pune", "Urbania for Outstation Pune"],
  ["Cheap Urbania Rent Pune", "Wedding Urbania Pune Hire"],
  ["Pune Urbania Cab Service", "Urbania Rental with Driver Pune"],
  ["Premium Urbania Van Pune", "Pune Urbania for Group Travel"],
  ["Best Urbania Rental Pune", "Force Urbania Rental Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Urbania on Rent in Pune",
        WhyChoosedescription: "Shivai Travels provides reliable Urbania rental service in Pune with professional drivers, luxury seating, and punctual pickup for smooth and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "Affordable Urbania Rental Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Urbania on rent in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Urbania Rental Availability",
        WhyChoosedescription: "Our Urbania rental service in Pune operates 24 hours a day for family tours, corporate outings, weddings, airport transfers, pilgrimage trips, and luxury group travel requirements."
      },
      {
        WhyChooseheading: "Luxury & Comfortable AC Urbania Vehicles",
        WhyChoosedescription: "All Urbania vehicles provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide premium travel comfort for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Urbania Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Urbania booking, round-trip travel, local sightseeing, outstation tours, and customized luxury travel packages."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Options",
        WhyChoosedescription: "Customers can choose from 10 seater, 13 seater, and 17 seater Force Urbania vehicles suitable for families, corporate groups, wedding guests, tourists, and VIP travel."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Luxury Group Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune city routes, highways, hill stations, Konkan roads, and pilgrimage destinations, ensuring safe driving and smooth travel for every luxury journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Urbania rental service in Pune?", answer: "Urbania rental service in Pune provides luxury group transportation for family trips, corporate travel, weddings, sightseeing tours, and outstation journeys." },
    { question: "Is Urbania on rent in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Urbania rental service in Pune." },
    { question: "Which Urbania seating options are available?", answer: "Shivai Travels offers 10 seater, 13 seater, and 17 seater Force Urbania vehicles." },
    { question: "Can I book Urbania for outstation travel?", answer: "Yes, customers can book Urbania vehicles for local sightseeing, outstation tours, corporate travel, and pilgrimage trips." },
    { question: "Do you provide one-way and round-trip Urbania service?", answer: "Yes, Shivai Travels provides both one-way and round-trip Urbania booking services." },
    { question: "Are all Urbania vehicles air-conditioned?", answer: "Yes, all Urbania vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book Urbania on rent in Pune online?", answer: "Yes, customers can easily book Urbania rental service online or through phone booking." },
    { question: "Do you provide Urbania vehicles for weddings and corporate events?", answer: "Yes, Shivai Travels provides Urbania vehicles for weddings, corporate outings, events, and family group travel." },
    { question: "Are Urbania rental fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Urbania rental in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Kulkarni",
      feedback:
        "Booked Urbania on rent in Pune with Shivai Travels. Luxury vehicle, smooth journey, and excellent driver support for our family trip.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Patil",
      feedback:
        "Excellent Urbania rental service in Pune. Affordable pricing, clean luxury vehicle, and wonderful group travel experience.",
      rating: 5
    }
  ];




  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];



















  return (
    <div>




      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/81.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinpune;